<template>
  <div class="container" @click="hide">
    <Header></Header>
    <div class="banner">
      <img src="../assets/images/img-hero-image-step123@2x.png" alt />
    </div>
    <div class="form-box">
      <div class="form-top">
        <div class="line"></div>
        <img class="icon left" src="../assets/images/icon-correct@2x.png" alt />
        <img class="icon mid" src="../assets/images/icon-personal-details@2x.png" alt />
        <img class="icon right" src="../assets/images/icon-payment-grey@2x.png" alt />
      </div>
      <div class="form-mid">
        <span class="left active" v-text="$t('msg.quantity')"></span>
        <span class="mid" v-text="$t('msg.personalDet')"></span>
        <span class="right" v-text="$t('msg.payment')"></span>
      </div>
      <div class="form-bottom">
        <h2 v-text="$t('msg.detailTopTip')"></h2>
        <div class="form-inner">
          <p v-text="$t('msg.nameLabel')"></p>
          <input :class="{requireClass:nameRequired}" type="text" v-model.trim="name" />
          <span v-if="nameRequired" v-text="$t('error.requiredErr')"></span>
        </div>
        <div class="form-inner">
          <p v-text="$t('msg.emailLabel')"></p>
          <input
            :class="{requireClass:emailRequired, emailErrClass:emailError}"
            type="text"
            v-model.trim="email"
          />
          <span v-if="emailRequired" v-text="$t('error.requiredErr')"></span>
          <span v-if="emailError" v-text="$t('error.emailError')"></span>
        </div>
        <div class="form-inner">
          <p v-text="$t('msg.confirmEmailLabel')"></p>
          <input
            :class="{requireClass:cEmailRequired, emailErrClass:cEmailError, emailDiffClass:emailDifferent}"
            type="text"
            v-model.trim="confirmEmail"
          />
          <span v-if="cEmailRequired" v-text="$t('error.requiredErr')"></span>
          <span v-if="cEmailError" v-text="$t('error.emailError')"></span>
          <span v-if="emailDifferent" v-text="$t('error.emailDifferent')"></span>
        </div>
        <div class="form-inner clearfix">
          <div class="country-code">
            <p v-text="$t('msg.countryCodeLabel')" style="line-height:20px;"></p>
            <div :class="{requireClass:codeRequired}" class="select-box">
              <span class="plus">+</span>
              <div class="code">
                <input
                  style="border:none;"
                  type="tel"
                  v-model.trim="countryCode"
                  @input="countryCodeInput($event)"
                  maxlength="6"
                />
              </div>
              <img
                class="arrow-down"
                src="../assets/images/arrow-country-code@2x.png"
                @click.stop="clickCountryCode"
              />
            </div>
            <span v-if="codeRequired" v-text="$t('error.requiredErr')"></span>
          </div>
          <div class="mobile-number">
            <p v-text="$t('msg.mobileNumberLabel')" style="line-height:20px;"></p>
            <input
              :class="{requireClass:mobileRequired}"
              type="tel"
              v-model.trim="mobileNumber"
              @input="mobileNumberInput($event)"
            />
            <span v-if="mobileRequired" v-text="$t('error.requiredErr')"></span>
          </div>
        </div>
        <h3 v-text="$t('msg.detailBotTip')"></h3>
        <div class="form-btn" v-text="$t('msg.continueBtn')" @click="nextStep">Continue</div>
        <ul class="select-list" v-show="showCountryList">
          <li
            v-for="(item, index) in countryList"
            :key="item.id"
            @click="selectCountryCode(index)"
            ref="countryData"
          >{{item.name}} (+{{item.telAbbr}})</li>
        </ul>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default {
  name: "pass",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      regexp: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      showCountryList: false,
      countryList: [],
      nameRequired: false,
      emailRequired: false,
      emailError: false,
      cEmailRequired: false,
      cEmailError: false,
      emailDifferent: false,
      codeRequired: false,
      mobileRequired: false,
      name: "",
      email: "",
      confirmEmail: "",
      countryCode: "",
      mobileNumber: ""
    };
  },
  mounted() {
    // 获取Token
    if (!localStorage.getItem("pass")) {
      this.$axios
        .post(
          "/api/auxiliary/getToken",
          {},
          {
            headers: {
              language: this.$i18n.locale
            }
          }
        )
        .then(res => {
          localStorage.setItem("pass", res.data.data);
          this.request();
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      this.request();
    }
    if (sessionStorage.getItem("detailData")) {
      var detailJsonStr = sessionStorage.getItem("detailData");
      var detailEntity = JSON.parse(detailJsonStr);
      this.name = detailEntity.name;
      this.email = detailEntity.email;
      this.confirmEmail = detailEntity.confirmEmail;
      this.countryCode = detailEntity.countryCode;
      this.mobileNumber = detailEntity.mobileNumber;
    }
  },
  methods: {
    request() {
      // 获取国家地区数据
      this.$axios
        .post(
          "/api/auxiliary/areaInfo",
          {},
          {
            headers: {
              language: this.$i18n.locale,
              token: localStorage.getItem("pass")
            }
          }
        )
        .then(res => {
          if (res.data.state === "11") {
            this.countryList = res.data.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    nextStep() {
      if (this.name === "" || this.name === null) {
        this.nameRequired = true;
      } else if (this.email === "" || this.email === null) {
        this.emailRequired = true;
      } else if (!this.regexp.test(this.email)) {
        this.emailError = true;
      } else if (this.confirmEmail === "" || this.confirmEmail === null) {
        this.cEmailRequired = true;
      } else if (!this.regexp.test(this.confirmEmail)) {
        this.cEmailError = true;
      } else if (this.email !== this.confirmEmail) {
        this.emailDifferent = true;
      } else if (this.countryCode === "" || this.countryCode === null) {
        this.codeRequired = true;
      } else if (this.mobileNumber === "" || this.mobileNumber === null) {
        this.mobileRequired = true;
      } else {
        var detailData = {
          name: this.name,
          email: this.email,
          confirmEmail: this.confirmEmail,
          countryCode: this.countryCode,
          mobileNumber: this.mobileNumber
        };
        sessionStorage.setItem("detailData", JSON.stringify(detailData));
        this.$router.push({
          path: "/payment"
        });
      }
    },
    clickCountryCode() {
      this.showCountryList = true;
    },
    selectCountryCode(i) {
      this.showCountryList = false;
      let str = this.$refs.countryData[i].innerText;
      let result = str.replace(/[^0-9]/gi, "");
      this.countryCode = result;
    },
    hide() {
      this.showCountryList = false;
    },
    countryCodeInput(e) {
      this.countryCode = e.target.value.replace(/[^\d]/g, "");
    },
    mobileNumberInput(e) {
      this.mobileNumber = e.target.value.replace(/[^\d]/g, "");
    }
  },
  watch: {
    name(curVal, oldVal) {
      if (curVal !== "") {
        this.nameRequired = false;
      }
    },
    email(curVal, oldVal) {
      if (curVal !== "") {
        this.emailRequired = false;
      }

      if (this.regexp.test(curVal)) {
        this.emailError = false;
      }
    },
    confirmEmail(curVal, oldVal) {
      if (curVal !== "") {
        this.cEmailRequired = false;
      }

      if (this.regexp.test(curVal)) {
        this.cEmailError = false;
      }

      if (this.email === curVal) {
        this.emailDifferent = false;
      }
    },
    countryCode(curVal, oldVal) {
      if (curVal !== "") {
        this.codeRequired = false;
      }
    },
    mobileNumber(curVal, oldVal) {
      if (curVal !== "") {
        this.mobileRequired = false;
      }
    }
  },
  computed: {
    count() {
      return this.$store.state.count;
    },
    currency() {
      return this.$store.state.currency;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  background: #f5f6fa;
}
/* .banner{height: 300px;} */
.banner img {
  width: 100%;
  height: 100%;
}
.form-top {
  width: 550px;
  margin: 50px auto 0;
  height: 100px;
  position: relative;
}
.form-top .line {
  width: 100%;
  height: 2px;
  background: #d1d3e0;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -1px;
}
.form-top .icon {
  width: 60px;
  height: 60px;
  position: absolute;
  top: 50%;
  margin-top: -30px;
  z-index: 2;
}
.form-top .left {
  left: -30px;
}
.form-top .mid {
  left: 50%;
  margin-left: -30px;
}
.form-top .right {
  right: -30px;
}
.form-mid {
  width: 550px;
  margin: 0 auto 70px;
  position: relative;
}
.form-mid span {
  font-size: 16px;
  font-weight: bold;
  color: #7b8090;
  text-align: center;
  position: absolute;
}
.form-mid .active {
  color: #4cc663;
}
.form-mid .left {
  width: 114px;
  left: -57px;
}
.form-mid .mid {
  width: 138px;
  left: 50%;
  margin-left: -69px;
}
.form-mid .right {
  width: 114px;
  right: -57px;
}
.form-bottom {
  width: 620px;
  margin: 0 auto;
  position: relative;
}
.form-bottom h2 {
  font-size: 16px;
  font-weight: normal;
  color: #2d354d;
  margin: 20px 0;
}
.form-inner {
  margin-bottom: 20px;
}
.form-inner p {
  font-size: 16px;
  font-weight: bold;
  color: #2d354d;
  margin-bottom: 10px;
}
.form-inner input {
  width: 96%;
  height: 30px;
  border: 1px #707070 solid;
  border-radius: 4px;
  font-size: 18px;
  outline: none;
  padding: 7px 2%;
}
.form-inner .requireClass {
  border: 1px #e73737 solid;
}
.form-inner .emailErrClass {
  border: 1px #e73737 solid;
}
.form-inner .emailDiffClass {
  border: 1px #e73737 solid;
}
.form-inner span {
  font-size: 12px;
  font-weight: bold;
  color: #e73737;
}
.form-bottom h3 {
  font-size: 12px;
  font-weight: normal;
}
.form-btn {
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: #910000;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  border-radius: 8px;
  margin: 30px 0 50px;
  cursor: pointer;
}
.country-code,
.mobile-number {
  float: left;
}
.country-code {
  width: 25%;
  margin-right: 2%;
}
.mobile-number {
  width: 73%;
}
.select-box {
  height: 44px;
  border: 1px #707070 solid;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
}
.select-box {
  background: #fff;
}
.select-box .plus {
  font-size: 16px;
  color: #2d354d;
  position: absolute;
  left: 10px;
  top: 10px;
}
.select-box .arrow-down {
  width: 23.4px;
  height: 12.4px;
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: -6.2px;
}
.select-box .code {
  height: 44px;
  line-height: 41px;
  margin-left: 30px;
}
.select-list {
  width: 377px;
  height: 554px;
  border: 1px #707070 solid;
  position: absolute;
  left: 0;
  top: 0;
  background: #fff;
  overflow-y: auto;
  z-index: 10;
}
.select-list li {
  height: 40px;
  line-height: 40px;
  font-size: 15px;
  color: #2d354c;
  padding-left: 15px;
  border-bottom: 1px #dddddd solid;
  cursor: pointer;
}

@media screen and (max-width: 640px) {
  /* .banner{height: 200px;} */
  .form-top .icon {
    width: 40px;
    height: 40px;
    margin-top: -20px;
  }
  .form-top .left {
    left: -20px;
  }
  .form-top .mid {
    margin-left: -20px;
  }
  .form-mid span {
    font-size: 10px;
  }
  .form-top .right {
    right: -20px;
  }
  .form-top,
  .form-mid {
    width: 70%;
  }
  .form-bottom {
    width: 90%;
  }
  .form-top {
    height: 70px;
    margin: 20px auto 0;
  }
  .form-mid {
    margin: 0 auto 60px;
  }
  .country-code,
  .mobile-number {
    width: 100%;
  }
  .country-code {
    margin-right: 0;
    margin-bottom: 20px;
  }
  .form-inner span {
    font-size: 10px;
  }
  .select-list {
    width: 90%;
    height: 400px;
    position: fixed;
    left: 50%;
    top: 5%;
    margin-left: -45%;
  }
  .form-inner input {
    width: 92%;
    padding: 7px 4%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Detail.vue